import { unreadScreenReaderWait } from 'config'
import { useI18n } from 'domains/i18n/hooks'
import { useVisibility } from 'domains/visibility/hooks'
import { useEffect, useMemo, useRef } from 'preact/hooks'
import { useLiveRegion, useSeamlyUnreadCount } from 'ui/hooks/seamly-hooks'
import { debounce } from 'ui/utils/general-utils'

const SeamlyReadState = () => {
  const { t } = useI18n()
  const { isOpen, isVisible } = useVisibility()
  const unreadCount = useSeamlyUnreadCount()
  const { sendPolite } = useLiveRegion()
  const sendLive = useMemo(
    () => debounce(sendPolite, unreadScreenReaderWait),
    [sendPolite],
  )

  const prevIsVisible = useRef<boolean | null>(null)
  const cancelSend = useRef<((_runInstant?: boolean) => void) | null>(null)

  useEffect(() => {
    if (
      prevIsVisible.current !== isVisible &&
      !isVisible &&
      cancelSend.current
    ) {
      cancelSend.current()
    }
    if (unreadCount !== 0 && !isOpen && isVisible) {
      cancelSend.current = sendLive(
        t('message.srTextUnreadCount', { unreadCount }),
      )
    }
    prevIsVisible.current = isVisible
  }, [unreadCount, isOpen, isVisible, sendLive, t])

  return null
}

export default SeamlyReadState
